module.exports = __webpack_public_path__ + "static/media/field.a9900439.png";